import { render, staticRenderFns } from "./NominalRollReport.vue?vue&type=template&id=19023cf1&scoped=true"
import script from "./NominalRollReport.vue?vue&type=script&lang=js"
export * from "./NominalRollReport.vue?vue&type=script&lang=js"
import style0 from "./NominalRollReport.vue?vue&type=style&index=0&id=19023cf1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19023cf1",
  null
  
)

export default component.exports